import script from "./CardUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./CardUpsert.vue?vue&type=style&index=0&id=de23dc64&lang=scss"

const __exports__ = script;

export default __exports__